import React from 'react';

import {
  BoldText,
  ClauseText,
  DangerText,
  InfoText,
} from './Components/ContractText';

interface PlannedCommunityProps {
  negotiationDaysFromDiscovery?: number;
}

const PlannedCommunity = ({
  negotiationDaysFromDiscovery,
}: PlannedCommunityProps) => {
  const daysLabel =
    typeof negotiationDaysFromDiscovery === 'number' &&
    Number.isFinite(negotiationDaysFromDiscovery) &&
    negotiationDaysFromDiscovery > 0
      ? String(negotiationDaysFromDiscovery)
      : '____';

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Planned Community/Homeowners Association Notice
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Homeowner's Association/Community Disclosure: Buyer should not execute
          this contract until buyer has received and read the Homeowners’
          Association/Community Disclosure, if applicable.
        </li>
        <li>
          Planned Community (Homeowner Association). The Property is part of a
          planned community, Seller to furnish Buyer with a copy of the
          declaration (other than plats and plans), the bylaws, the rules and
          regulations of the association, and a Certificate.
        </li>
        <li>
          If this is the first sale of the property after creation of the
          condominium or planned community (therefore a sale by the Declarant),
          Seller shall furnish Buyer with a Public Offering Statement no later
          than the date Buyer executes this Agreement. Buyer may void this
          Agreement within 15 days (if a condominium) or within 7 days (if part
          of a planned community) after receipt of the Public Offering Statement
          or any amendment to the Statement that materially and adversely
          affects Buyer. Upon Buyer declaring this Agreement void, all deposit
          money will be returned to Buyer according to the terms of this
          Agreement .
        </li>
        <li>
          Within <InfoText>{daysLabel}</InfoText> days from the Execution Date
          of this Agreement, Seller, at Seller’s expense, will request from the
          association a Certificate of Resale and any other documents necessary
          to enable Seller to comply with the relevant Act. Among certain
          states, the association is required to provide these documents within
          10 days of Seller’s request. Seller will promptly deliver to Buyer all
          documents received from the association. Under the Act, Seller is not
          liable to Buyer for the failure of the association to provide the
          Certificate in a timely manner or for any incorrect information
          provided by the association in the Certificate. The Act provides that
          Buyer may declare this Agreement VOID at any time before Buyer
          receives the association documents and for 5 days after receipt, OR
          until settlement, whichever occurs first. Buyer’s notice to Seller
          must be in writing upon Buyer declaring this Agreement void , all
          deposit money will be returned to Buyer according to the terms of this
          Agreement .
        </li>
        <li>
          If the association has the right to buy the Property (right of first
          refusal), and the association exercises that right, Seller will
          reimburse Buyer for any costs incurred by Buyer for any inspections or
          certifications obtained according to the terms of the Agreement, and
          any costs incurred by Buyer for:
        </li>
        <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
          <li>
            Title search, title insurance and/or mechanics’ lien insurance, or
            any fee for cancellation;
          </li>
          <li>
            Flood insurance, fire insurance, hazard insurance, mine subsidence
            insurance, or any fee for cancellation;
          </li>
          <li>
            Appraisal fees and charges paid in advance to mortgage lender.
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default PlannedCommunity;
